var _excluded = ["children"],
  _excluded2 = ["onChange", "onReject", "id", "icon", "children", "className", "accept", "name", "maxFiles", "maxSize", "minSize", "multiple"],
  _excluded3 = ["onChange", "onReject", "id", "children", "className", "accept", "name", "maxFiles", "maxSize", "minSize", "multiple"],
  _excluded4 = ["file", "documentTypes", "documentType", "description", "onChange", "onRemoveFile", "removeButtonText", "sizeLabel", "filenameLabel", "documentTypeLabel", "descriptionLabel", "characterLimitErrorMessage", "charactersLabelText", "children", "removeIcon", "fileIcon", "formattedFileSize"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FaCloudUploadAlt, FaFileImage, FaFilePdf, FaFileWord } from 'react-icons/fa';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { useId } from '../../hooks';
import { forwardRef, tqc, useMultiStyleConfig } from '../../system';
import { cx, split, __DEV__ } from '../../utils';
import { mergeRefs } from '../../utils/react-helpers';
import { FormControl, FormErrorMessage, FormLabel } from '../form-control';
import { Card, Flex, HStack, LinkButton, Stack, Text } from '../layout';
import { Select } from '../select';
import { Textarea } from '../textarea';
var dropzoneProps = ['noDrag', 'noClick', 'noKeyboard', 'onDrop', 'onFileDialogCancel'];
var DefaultIcon = tqc(FaCloudUploadAlt);
var RemoveButtonIcon = tqc(RiDeleteBin6Fill);
var PdfFileIcon = tqc(FaFilePdf);
var ImageFileIcon = tqc(FaFileImage);
var DocFileIcon = tqc(FaFileWord);
var FileDragDropIcon = props => {
  var {
      children = /*#__PURE__*/React.createElement(DefaultIcon, {
        __css: {
          width: '100%',
          height: 'auto',
          color: 'currentColor'
        }
      })
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var clone = /*#__PURE__*/React.cloneElement(children, {
    className: 'tqc-file-dragdrop__icon',
    role: 'presentation',
    focusable: false,
    'aria-hidden': true
  });
  return /*#__PURE__*/React.createElement(tqc.div, _extends({}, rest, {
    className: "tqc-file-dragdrop__icon-wrapper"
  }), /*#__PURE__*/React.isValidElement(children) ? clone : null);
};
if (__DEV__) {
  FileDragDropIcon.displayName = 'FileDragDropIcon';
}
export var FileDragDrop = forwardRef((props, ref) => {
  var {
      onChange,
      onReject,
      id: idProp,
      icon,
      children,
      className,
      accept,
      name,
      maxFiles = 0,
      maxSize = Infinity,
      minSize = 0,
      multiple: multipleProp
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var textLabelId = useId(undefined, 'file-dragdrop');
  var multiple = multipleProp === undefined ? maxFiles > 0 : multipleProp;
  var [dzoneProps, htmlProps] = split(rest, dropzoneProps);
  var {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    isDragAccept,
    isFocused
  } = useDropzone(_objectSpread(_objectSpread({}, dzoneProps), {}, {
    onDropAccepted: onChange,
    onDropRejected: onReject,
    accept,
    maxFiles,
    minSize,
    maxSize,
    multiple
  }));
  var styles = useMultiStyleConfig('FileDragDrop', _objectSpread(_objectSpread({}, props), {}, {
    isDragActive,
    isDragAccept,
    isDragReject,
    isFocused
  }));
  var inputProps = getInputProps();
  inputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
    ref: mergeRefs(inputProps.ref, ref)
  });
  return /*#__PURE__*/React.createElement(tqc.div, _extends({}, getRootProps(), {
    className: cx('tqc-file-dragdrop', className),
    role: "button",
    __css: styles.container
  }, htmlProps), /*#__PURE__*/React.createElement("input", _extends({
    "aria-describedby": textLabelId,
    id: idProp
  }, inputProps, {
    name: name
  })), /*#__PURE__*/React.createElement(FileDragDropIcon, {
    __css: styles.iconWrapper
  }, icon), /*#__PURE__*/React.createElement(Text, {
    className: "tqc-file-dragdrop__text",
    id: textLabelId,
    sx: styles.text
  }, children));
});
if (__DEV__) {
  FileDragDrop.displayName = 'FileDragDrop';
}
export var FileUpload = forwardRef((props, ref) => {
  var {
      onChange,
      onReject,
      id: idProp,
      children,
      className,
      accept,
      name,
      maxFiles = 0,
      maxSize = Infinity,
      minSize = 0,
      multiple: multipleProp
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var textLabelId = useId(undefined, 'file-dragdrop');
  var multiple = multipleProp === undefined ? maxFiles > 0 : multipleProp;
  var [dzoneProps, htmlProps] = split(rest, dropzoneProps);
  var {
    getRootProps,
    getInputProps
  } = useDropzone(_objectSpread(_objectSpread({}, dzoneProps), {}, {
    onDropAccepted: onChange,
    onDropRejected: onReject,
    accept,
    maxFiles,
    minSize,
    maxSize,
    multiple
  }));
  var inputProps = getInputProps();
  inputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
    ref: mergeRefs(inputProps.ref, ref)
  });
  return /*#__PURE__*/React.createElement(tqc.div, _extends({}, getRootProps(), {
    className: cx('tqc-file-dragdrop', className),
    role: "button"
  }, htmlProps), /*#__PURE__*/React.createElement("input", _extends({
    "aria-describedby": textLabelId,
    id: idProp
  }, inputProps, {
    name: name
  })), children);
});
if (__DEV__) {
  FileUpload.displayName = 'FileUpload';
}
export var FilePreviewItem = props => {
  var {
      file,
      documentTypes,
      documentType = '',
      description = '',
      onChange,
      onRemoveFile,
      removeButtonText,
      sizeLabel,
      filenameLabel,
      documentTypeLabel,
      descriptionLabel,
      characterLimitErrorMessage,
      charactersLabelText,
      children,
      removeIcon,
      fileIcon,
      formattedFileSize
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  var [document, setDocument] = React.useState({
    description,
    documentType
  });
  function formatFileSize() {
    if (file.size === 0) return '0 bytes';
    var k = 1024;
    var sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
    var i = Math.floor(Math.log(file.size) / Math.log(k));
    return parseFloat((file.size / Math.pow(k, i)).toFixed(0)) + sizes[i];
  }
  function getFileIcon() {
    if (file.type.includes('image')) return ImageFileIcon;
    if (file.type.includes('word')) return DocFileIcon;
    return PdfFileIcon;
  }
  function handleChange(documentChanged) {
    var updatedDocument = _objectSpread(_objectSpread({}, document), documentChanged);
    setDocument(updatedDocument);
    onChange(updatedDocument);
  }
  var characterLimit = 250;
  var descriptionLength = document.description ? document.description.length : 0;
  var hasExceededCharacterLimit = document.description ? descriptionLength > characterLimit : undefined;
  var FileIcon = getFileIcon();
  return /*#__PURE__*/React.createElement(Card, _extends({
    sx: {
      p: 6,
      overflow: 'visible'
    }
  }, rest), /*#__PURE__*/React.createElement(Stack, {
    spacing: 6
  }, /*#__PURE__*/React.createElement(HStack, {
    ml: "auto",
    d: ['flex', 'none']
  }, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: onRemoveFile
  }, removeButtonText), removeIcon ? removeIcon : /*#__PURE__*/React.createElement(RemoveButtonIcon, {
    __css: {
      fontSize: 'lg',
      color: 'blue.600'
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: ['column', 'row']
  }, /*#__PURE__*/React.createElement(HStack, {
    sx: {
      flex: 1,
      mr: [0, 6]
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, filenameLabel, " "), /*#__PURE__*/React.createElement(HStack, null, fileIcon ? fileIcon : /*#__PURE__*/React.createElement(FileIcon, {
    __css: {
      fontSize: 'lg',
      color: 'red.500'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    whiteSpace: "pre-wrap",
    wordBreak: "break-all"
  }, file.name))), /*#__PURE__*/React.createElement(HStack, {
    sx: {
      mt: [6, 0],
      flex: 1.2,
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, sizeLabel, " "), /*#__PURE__*/React.createElement(Text, null, formattedFileSize ? formattedFileSize : formatFileSize())), /*#__PURE__*/React.createElement(HStack, {
    d: ['none', 'flex']
  }, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: onRemoveFile
  }, removeButtonText), removeIcon ? removeIcon : /*#__PURE__*/React.createElement(RemoveButtonIcon, {
    __css: {
      fontSize: 'lg',
      color: 'blue.600'
    }
  })))), children ? children : /*#__PURE__*/React.createElement(Flex, {
    direction: ['column', 'row']
  }, /*#__PURE__*/React.createElement(FormControl, {
    id: "document-type",
    isRequired: true,
    sx: {
      flex: 1,
      mr: [0, 6]
    }
  }, /*#__PURE__*/React.createElement(FormLabel, null, documentTypeLabel), /*#__PURE__*/React.createElement(Select, {
    name: "select-document-type",
    onChange: selectedDocument => handleChange({
      documentType: selectedDocument
    }),
    placeholder: "Select document type"
  }, documentTypes.map(documentType => /*#__PURE__*/React.createElement("option", {
    key: documentType,
    value: documentType
  }, documentType)))), /*#__PURE__*/React.createElement(FormControl, {
    sx: {
      flex: 1.2,
      mt: [8, 0]
    },
    id: "document-description",
    isInvalid: hasExceededCharacterLimit
  }, /*#__PURE__*/React.createElement(FormLabel, null, descriptionLabel), /*#__PURE__*/React.createElement(Textarea, {
    onChange: e => handleChange({
      description: e.target.value
    }),
    value: document.description
  }), /*#__PURE__*/React.createElement(FormErrorMessage, {
    mt: 3,
    fontSize: "sm",
    lineHeight: "short",
    fontWeight: 'bold'
  }, characterLimitErrorMessage), /*#__PURE__*/React.createElement(Text, {
    mt: 2,
    fontSize: "sm",
    lineHeight: "short",
    sx: hasExceededCharacterLimit ? {
      color: 'red.700',
      fontWeight: 'bold'
    } : undefined
  }, descriptionLength, " of ", characterLimit, " ", charactersLabelText)))));
};